import BlackListPage from './components/Page';
export default BlackListPage;
